import { CarrierInformation } from "./carrier-information";
import { OrderNumberInformation } from "./order-number-information";
import React from "react";
import { Step } from "./step";
import { useAuth } from "../../../../../../../public/auth/infrastructure/store/auth-context";
import { useGetOrderByMovement } from "../../../../services";
import { Button, Input } from "../../../../../../../shared/infrastructure";
import { GeneralStepProps, OfferFormT } from "./types";
import { useFormContext, useWatch } from "react-hook-form";

export const OfferSummaryStep = ({
  setStep,
  isLoading,
}: GeneralStepProps & {
  isLoading: boolean;
}): React.ReactElement => {
  const { user } = useAuth();
  const { control } = useFormContext<OfferFormT>();
  const [order, carrier, rate, commission] = useWatch({
    control,
    name: ["order", "carrier", "rate", "commission"],
  });

  const { data } = useGetOrderByMovement(order?.movementNumber ?? "", {
    enabled: !!order?.movementNumber,
  });

  return (
    <Step
      title="Summary"
      prevStep={() => setStep("offer-form")}
      actions={
        <section className="mt-[20px] grid place-content-center">
          <Button
            className="w-auto bg-[#3C7CF3] px-[16px] py-[6px] text-[12px]"
            status={isLoading ? "loading" : "default"}
            type="submit"
          >
            Checkout
          </Button>
        </section>
      }
    >
      {order &&
        carrier &&
        rate !== undefined &&
        commission !== undefined &&
        data?.data && (
          <section className="grid gap-[16px]">
            <OrderNumberInformation order={data?.data} />
            <CarrierInformation carrier={carrier} />

            <span className="block h-[1px] w-full border-b-[1px] border-solid border-[#D6D6D6]" />

            <section className="flex flex-row justify-between">
              <section className="grid grid-flow-col justify-start gap-[10px] text-[14px]">
                <span>Rate:</span>
                <span className="text-[#4CAF50]">
                  {rate ? `${rate.toLocaleString("en-US")} USD` : "- -"}
                </span>
              </section>
              {user?.dispatch_division?.country !== "Colombia" ? (
                <section className="grid grid-flow-col justify-start gap-[10px] text-[14px]">
                  <span>Commission:</span>
                  <span className="text-[#2196F3]">
                    {commission.toLocaleString("en-US")} USD
                  </span>
                </section>
              ) : (
                <section />
              )}
              <section className="grid grid-flow-col justify-start gap-[10px] text-[14px]">
                <span>Max buy:</span>
                <span className="text-[#F44336]">
                  {data?.data?.max_buy
                    ? `${data.data.max_buy.toLocaleString("en-US")} USD`
                    : "- -"}
                </span>
              </section>
            </section>
            <section className="">
              <Input
                name="comments"
                placeholder="Comments"
                type="text"
                variant="outlined"
                multiline={true}
                rows={3}
                inputProps={{ disableUnderline: true }}
                rootInputProps={{
                  className: "text-[12px]",
                }}
                classNames={{ formControl: "w-full" }}
              />
            </section>
          </section>
        )}
    </Step>
  );
};
